import styled from 'styled-components';
import { colors } from 'Constants/Colors';

export const MembersContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${colors.BLUE_GRAY};
  width: 100%;
  height: auto;
`;

export const dropdownStyle = { display: 'flex', justifyContent: 'flex-end' };

export const ContainerTable = styled.div`
  margin: auto;
  width: 98%;
`;

export default {
  MembersContainer,
  dropdownStyle,
  ContainerTable,
};
